import { AppRoutes } from '../../constants/appRoutes';
import { entityNames } from '../../constants/entities';
import { EDetailsQueryNames } from '../../constants/queryNames';
import { Organisation } from '../../models/stack9/Organisation';
import { EntityDrawer } from '../EntityDrawer/EntityDrawer';

type OrganisationDrawerProps = {
  open: boolean;
  onClose: () => void;
  id?: number;
  initialValues?: Partial<Organisation>;
};

export const OrganisationDrawer = ({
  open,
  onClose,
  id,
  initialValues,
}: OrganisationDrawerProps) => {
  const formFields = [
    { field: 'account_id', label: 'Account' },
    { field: 'registered_name', colSize: 12 },
    { field: 'registered_number', colSize: 12 },
    { field: 'trade_as_name', colSize: 12 },
    { field: 'partner_id', colSize: 12, label: 'Partner' },
    { field: 'main_industry_name', colSize: 12 },
    { field: 'main_industry_code', colSize: 12 },
    {
      field: 'secondary_industry_name',
      colSize: 12,
    },
    {
      field: 'secondary_industry_code',
      colSize: 12,
    },
    { field: 'payment_waiver_end_dt' },
    { field: 'address_line_1' },
    { field: 'address_line_2' },
    { field: 'suburb', colSize: 6 },
    { field: 'post_code', colSize: 6 },
    { field: 'state', colSize: 6 },
    { field: 'country', colSize: 6 },
    { field: 'is_active' },
  ];

  return (
    <EntityDrawer
      title="organisation"
      open={open}
      onClose={onClose}
      screenQueryName={EDetailsQueryNames.GetOrganisationDetails}
      entityName={entityNames.ORGANISATION}
      editRoute={AppRoutes.OrganisationDetail}
      relativePath={AppRoutes.OrganisationDetail}
      formFields={formFields}
      initialValues={initialValues}
      id={id}
    />
  );
};
